'use strict';

/**
 * Message sent by a newcommer to its contact when it joins the network.
 */
class MJoin {
    constructor () {
        this.type = 'MJoin';
    };
};

module.exports = MJoin;
